
import React, { useEffect, useState } from 'react'
import { send_recommendation, Get_Recommendation } from '../../../../api/global/Global.js'
import Header from '../../../common/header/Header.js';
import Footer from '../../../common/footer/Footer.js';
import { Helmet } from 'react-helmet';
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config.js';
import Loader from '../../../../loader/Loader.js';
import { isValidEmail, isAlphabetical } from '../../../validation/Validation.js';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Recommend_Gemstone = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        gender: '',
        purpose: '',
        budget: '',
        weight: '',
        placeOfBirth: '',
        dob: null,
    });
    const [recommendation_data, set_Recommendation_Data] = useState({})
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);
    const [messageColor, setMessageColor] = useState(null);

    const handleChange = (e) => {
        setMessage(null)
        setErrors({})

        const { name, value } = e.target;
        if (name === "phone" && value.length > 10) {
            return
        }


        if (name === "name" && value?.length && !isAlphabetical(value)) {
            setMessageColor("red");
            setMessage("Name should only contain alphabetic characters");
            return;
        }

        if (name === "email") {
            if (!isValidEmail(value)) {
                setMessageColor("red")
                setMessage("Please enter a valid email address");
            } else {
                setMessage("");
            }
        }

        if (name === "placeOfBirth" && value && !isAlphabetical(value)) {
            setMessageColor("red");
            setMessage("Birth Place should only contain alphabetic characters");
            return;
        }

        if (name === "dob") {
            const year = value.split("-")[0];
            if (year.length > 4) return; // Block input with more than 4 digit year
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const newErrors = {};

    const resetMessages = () => {
        setMessage('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setErrors({});
        setMessage('');

        const newErrors = {};

        // Required field validation
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.phone) newErrors.phone = "Phone number is required";
        if (!formData.gender) newErrors.gender = "Gender is required";
        if (!formData.purpose) newErrors.purpose = "Purpose is required";
        if (!formData.weight) newErrors.weight = "Weight is required";
        if (!formData.placeOfBirth) newErrors.placeOfBirth = "Place of birth is required";
        if (!formData.dob) newErrors.dob = "Birth date and time are required";


        // Stop if required validation fails
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Field format validations
        if (!isAlphabetical(formData.name)) {
            toast("Name should only contain alphabetic characters");
            return;
        }

        if (!isValidEmail(formData.email)) {
            toast("Please enter a valid email address");
            return;
        }

        // Combine DOB date + time
        const dateObj = new Date(formData.dob);

        // Format YYYY-MM-DD
        const dob = dateObj.toISOString().split("T")[0];

        // Format HH:mm:ss (LOCAL time, not UTC)
        const hours = String(dateObj.getHours()).padStart(2, "0");
        const minutes = String(dateObj.getMinutes()).padStart(2, "0");
        const seconds = String(dateObj.getSeconds()).padStart(2, "0");

        const birth_time = `${dob} ${hours}:${minutes}:${seconds}`;



        const payload = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            gender: formData.gender,
            purpose: formData.purpose,
            budget: formData.budget,
            placeOfBirth: formData.placeOfBirth,
            dob: formData.dob.toISOString(), 
        };


        try {
            const response = await send_recommendation(payload);

            if (response?.data?.status === 200) {
                setMessageColor("green");
                setMessage(response?.data?.message);

                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    gender: '',
                    purpose: '',
                    budget: '',
                    weight: '',
                    placeOfBirth: '',
                    dob: null,
                });

                setTimeout(() => {
                    setMessage('');
                }, 2000);

            } else if (response?.response?.data?.status === 500) {
                setMessageColor("red");
                setMessage(response?.response?.data?.message);

                setTimeout(() => {
                    setMessage('');
                }, 2000);
            }

        } catch (error) {
            console.error("Submit error:", error);
            toast("Something went wrong. Please try again.");
        }
    };


    useEffect(() => {
        const get_global_setting = async () => {
            setLoading(true)
            try {
                const response = await Get_Recommendation()
                if (response?.data?.status == 200) {
                    set_Recommendation_Data(response?.data?.data?.recommendation
                    )
                } else if (response?.response?.data?.status == 500) {

                }
            } catch (error) {

            } finally {
                setLoading(false)
            }
        }
        get_global_setting()
    }, [])


    const convertToEmbedUrl = (url) => {
        const videoId = url?.split("v=")[1]?.split("&")[0];
        return `https://www.youtube.com/embed/${videoId}`;
    };

    return (
        <div>
            {
                loading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{recommendation_data?.meta_title}</title>
                            <meta name="description" content={recommendation_data?.meta_description
                                || "description"} />

                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}recommend-gemstone`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}recommend-gemstone`} />

                        </Helmet>

                        <Header />

                        <section className='banner-section'>
                            <div className={`${recommendation_data?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${recommendation_data?.image}`} alt={recommendation_data?.alt_image
                                } className='w-full h-[300px]' />
                            </div>
                        </section>
                        <div className='pb-4'>
                            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="kundli_form w-full mt-6 mb-6">
                                    <h1 class="text-2xl font-bold text-gray-800 mb-5 border-b border-gray-300 pb-3 text-center">{recommendation_data?.main_title}</h1>
                                    <div className="flex flex-col md:flex-row w-full gap-6">
                                        <div
                                            className="w-full lg:w-1/2">
                                            <div className="w-full">
                                                <div className="mb-4">
                                                    <h2 className="mb-2 text-lg font-semibold text-gray-900">{recommendation_data?.title1}</h2>
                                                    <span className="text-sm text-gray-500">{recommendation_data?.sub_title1}</span>
                                                </div>
                                                <div className="bg-gray-100 p-6">
                                                    {message && (
                                                        <span className={` text-${messageColor}-500 font-semibold text-[16px]`}>{message}</span>
                                                    )}

                                                    <form onSubmit={handleSubmit} method="post">
                                                        <div className="space-y-3">
                                                            <div className="input-grid flex space-x-2.5">
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">
                                                                        Name*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white relative ">
                                                                            <input placeholder="Name"
                                                                                name="name"
                                                                                value={formData.name}
                                                                                onChange={handleChange}
                                                                                className="input-field  placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px] w-full"
                                                                                type="text" />

                                                                        </div>
                                                                        {errors.name && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Email ID*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white  overflow-hidden relative ">
                                                                            <input placeholder="Email id"
                                                                                name="email"
                                                                                value={formData.email}
                                                                                onChange={handleChange}
                                                                                className="input-field placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px] w-full"
                                                                                type="email" />

                                                                        </div>
                                                                        {errors.email && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input-grid flex space-x-2.5">
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Phone No.*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white overflow-hidden relative ">
                                                                            <input type="number" name="phone"
                                                                                value={formData.phone}
                                                                                onChange={handleChange}
                                                                                maxlength="10" placeholder="Enter your number"
                                                                                class="input-field placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px] w-full"
                                                                            />
                                                                        </div>
                                                                        {errors.phone && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Select Gender*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white  overflow-hidden relative ">
                                                                            <select
                                                                                name="gender"
                                                                                value={formData.gender}
                                                                                onChange={handleChange}
                                                                                className="input-field w-full placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]">
                                                                                <option value="">Select</option>
                                                                                <option value="male">Male</option>
                                                                                <option value="female">Female</option>
                                                                            </select>
                                                                        </div>
                                                                        {errors.gender && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.gender}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input-grid flex space-x-2.5">
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Select Purpose*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white  overflow-hidden relative ">
                                                                            <select
                                                                                name="purpose"
                                                                                value={formData.purpose}
                                                                                onChange={handleChange}
                                                                                className="input-field w-full placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]">
                                                                                <option value="">Select</option>
                                                                                <option value="general">General</option>
                                                                                <option value="health">Health</option>
                                                                                <option value="career">Career</option>
                                                                                <option value="wealth and fortune">Wealth and Fortune</option>
                                                                                <option value="education">Education</option>
                                                                                <option value="personal relations">Personal Relations</option>
                                                                            </select>
                                                                        </div>
                                                                        {errors.purpose && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.purpose}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Select Budget</label>
                                                                        <div
                                                                            className="input-wrapper bg-white  overflow-hidden relative ">
                                                                            <select
                                                                                name="budget"
                                                                                value={formData.budget}
                                                                                onChange={handleChange}
                                                                                className="input-field w-full placeholder:text-sm text-sm px-4 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]">
                                                                                <option>Select</option>
                                                                                <option>Rs.10,000 & Under</option>
                                                                                <option>Rs.10,000-Rs.50,000</option>
                                                                                <option>Rs.50,000-Rs.100,000</option>
                                                                                <option>Rs.100,000 & Over</option>
                                                                            </select>
                                                                            {errors.budget && (
                                                                                <p className="text-red-500 text-sm mt-1">{errors.budget}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="input-grid flex space-x-2.5">
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Body Weight (in kgs)*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white overflow-hidden relative ">
                                                                            <input type="number"
                                                                                name="weight"
                                                                                value={formData.weight}
                                                                                onChange={handleChange}
                                                                                placeholder="Enter Weight"
                                                                                class="w-full px-4 bg-transparent border-0 text-[#777] text-[14px] outline-[0] h-[40px]"
                                                                            />
                                                                        </div>
                                                                        {errors.weight && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.weight}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="w-1/2 h-full">
                                                                    <div className="input-com "><label
                                                                        className="text-gray-600 text-sm pb-1 inline-block">Place of Birth*</label>
                                                                        <div
                                                                            className="input-wrapper bg-white overflow-hidden relative ">
                                                                            <input type="text"
                                                                                name="placeOfBirth"
                                                                                value={formData.placeOfBirth}
                                                                                onChange={handleChange}
                                                                                placeholder="Enter place of birth"
                                                                                class="w-full px-4 bg-transparent border-0 text-[#777] text-[14px] outline-[0] h-[40px]"
                                                                            />
                                                                        </div>
                                                                        {errors.placeOfBirth && (
                                                                            <p className="text-red-500 text-sm mt-1">{errors.placeOfBirth}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="w-full">
                                                                <label className="text-gray-600 text-sm pb-1 inline-block">
                                                                    Birth Date & Time*
                                                                </label>
                                                                <br />
                                                                <DatePicker
                                                                    selected={formData.dob}
                                                                    onChange={(date) =>
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            dob: date,
                                                                        }))
                                                                    }

                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={1}
                                                                    dateFormat="yyyy-MM-dd HH:mm"

                                                                    // ✅ Important additions
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    scrollableYearDropdown
                                                                    yearDropdownItemNumber={120}

                                                                    maxDate={new Date()}
                                                                    placeholderText="Select birth date & time"
                                                                    className="input-field w-full text-sm px-4 h-[40px] border border-gray-300"
                                                                    wrapperClassName="w-full"
                                                                />


                                                                {errors.dob && (
                                                                    <p className="text-red-500 text-sm mt-1">{errors.dob}</p>
                                                                )}
                                                            </div>


                                                            <div className="input-grid">
                                                                <div className="w-full">
                                                                    <div className="input-com "><button type="submit"
                                                                        className="w-full h-[45px] bg-gradient-to-r from-[#9f2225] to-[#FFB500] hover:from-[#b14848] hover:to-[#e0b341] text-white text-sm">Get Recommendation Now</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="bg-whitew-full lg:w-1/2 lg:px-0 px-1">
                                            <div className="mb-4">
                                                <h2 className="mb-2 text-lg font-semibold text-gray-900">{recommendation_data?.title2}</h2>
                                                <span className="text-sm text-gray-500">{recommendation_data?.sub_title2}</span>
                                            </div>
                                            <iframe
                                                src={convertToEmbedUrl(recommendation_data?.url)}
                                                width="100%"
                                                height="510"
                                                title="Video"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>

                                <div class="sub__title" dangerouslySetInnerHTML={{ __html: recommendation_data?.description }} />
                            </div>
                        </div>


                        {/* <---------- footer------------> */}
                        <Footer />
                    </>
                )
            }
        </div>
    )
}

export default Recommend_Gemstone
